import React from "../../__compat__/react/main.entry.mjs.mjs";
import { SkeletonShape } from "../SkeletonShape/SkeletonShape.mjs.mjs";
import { BTN_SIZE_M, BTN_SIZE_S } from "./Button.styles.mjs.mjs";
function dimensionsFrom(props) {
    const regularWidth = props.width || (props.size === 'small' ? '100px' : '144px');
    switch (props.variant) {
        case 'primary':
        case 'secondary':
            return {
                width: regularWidth,
                height: props.size === 'small' ? BTN_SIZE_S : BTN_SIZE_M,
            };
        case 'text':
            return {
                width: regularWidth,
                height: props.size === 'small' ? '22px' : '26px',
            };
        case 'icon-primary':
        case 'icon-secondary':
        case 'icon-tertiary':
            return {
                width: props.size === 'small' ? '48px' : '56px',
                height: props.size === 'small' ? '48px' : '56px',
            };
    }
}
export const ButtonSkeleton = (props) => {
    const variant = props.loading ? 'circular' : 'rectangular';
    const dimensions = dimensionsFrom(props);
    return (React.createElement(SkeletonShape, { variant: variant, width: dimensions.width, height: dimensions.height }));
};
//# sourceMappingURL=Button.skeleton.mjs.mjs.map